
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"transform":"translate(5.093 16)"}},[_c('path',{attrs:{"stroke":"#E9ECED","stroke-linejoin":"round","stroke-width":"2","d":"M26.433 11.219v20.443h25.79a.93.93 0 00.93-.93V11.506a.93.93 0 00-.172-.539L45.465.391A.93.93 0 0044.708 0H26.192h0l.24 11.199a.93.93 0 01.001.02z"}}),_c('path',{attrs:{"fill":"#FFF","stroke":"#E9ECED","stroke-linecap":"square","stroke-width":"2","d":"M28.516 11.621h24.172"}}),_c('path',{attrs:{"stroke":"#D6DBEA","stroke-width":"2","d":"M0 11.516v19.216c0 .514.416.93.93.93h25.79V0h0H8.774a.93.93 0 00-.747.376L.183 10.962a.93.93 0 00-.183.554z"}}),_c('rect',{attrs:{"width":"5.578","height":"10.227","x":"42.926","y":"21.383","stroke":"#E9ECED","stroke-width":"1.859","rx":".93"}}),_c('rect',{attrs:{"width":"5.438","height":"10.086","x":"16.036","y":"21.453","stroke":"#D6DBEA","stroke-width":"2","rx":".93"}}),_c('rect',{attrs:{"width":"5.578","height":"5.578","x":"31.77","y":"15.805","stroke":"#E9ECED","stroke-width":"1.859","rx":".93"}}),_c('rect',{attrs:{"width":"5.438","height":"5.438","x":"4.879","y":"15.875","stroke":"#D6DBEA","stroke-width":"2","rx":".93"}}),_c('path',{attrs:{"fill":"#F4FBFE","stroke":"#D6DBEA","stroke-linecap":"square","stroke-width":"2","d":"M1.555 11.621h24.172"}})]),_c('path',{attrs:{"stroke":"#D6DBEA","stroke-linecap":"round","stroke-width":"2","d":"M2.465 47.707h58.57"}})])])
          )
        }
      }
    